// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mareanie: PokeData = {
  "id": 747,
  "name": "mareanie",
  "height": 4,
  "weight": 80,
  "base_experience": 61,
  "types": [
    PokeType.POISON,
    PokeType.WATER
  ],
  "api_moves": [
    "poison-sting",
    "pin-missile",
    "bite",
    "peck",
    "toxic",
    "recover",
    "spike-cannon",
    "toxic-spikes",
    "poison-jab",
    "wide-guard",
    "venoshock",
    "acid-spray",
    "venom-drench",
    "liquidation"
  ],
  "moves": [
    "pin-missile",
    "bite",
    "peck",
    "toxic-spikes",
    "poison-jab",
    "venom-drench",
    "liquidation",
    "acid",
    "rain-dance",
    "life-dew",
    "bubble-beam",
    "water-spout",
    "hydro-pump"
  ],
  "evolution_chain": {
    "id": 385,
    "item": null,
    "species": [
      {
        "name": "mareanie",
        "order": 747,
        "types": [
          PokeType.POISON,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toxapex",
        "order": 748,
        "types": [
          PokeType.POISON,
          PokeType.WATER
        ],
        "evolves_from_species_id": 747,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.5,
    "speed": 45,
    "ability_power": 53
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
